/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestPlansIfNotRequested } from 'state/dispatch-plans/actions';
import { getAllDispatchPlans, requestingDispatchPlans } from 'state/dispatch-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { getCurrentDispatchId, getCurrentDispatchPlanId, getCurrentDispatch } from 'state/current-dispatch/selectors';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { requestCurrentDispatch } from 'state/current-dispatch/actions';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import FlashMessage from 'components/flash-message';
import page from 'page';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectDispatchPlan = (props) => {
    const dispatchPlans = props.dispatchPlans;
    const [submitting, setSubmitting] = useState(false);

    const onChange = (value) => {
        if (!props.dispatchSubscriptionId) {
            return newPlanSubscription(value);
        }

        let plan = find(dispatchPlans, { id: value });
        let addon = resolveLicenseAddon(plan);
    };

    useEffect(() => {
        props.requestDispatchPlans();
        props.requestAddons();
        props.requestCoupons();
    }, []);

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.dispatchSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Dispatch Module subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const newPlanSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newPlanSubscription(planId),
            error: (e) => console.log(e),
            // close: () => { window.location.reload(); },
            success: () => {
                props.requestCurrentDispatch();
                props.successNotice('Your Dispatch Module subscription has been created.');
                page.redirect('/dashboard/dispatch');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {
        return null;
    };

    if (props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {dispatchPlans.map((plan, i) => {
                        return (
                            <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentDispatch && props.currentDispatch.status == 'cancelled')
                                        ? plan.id == props.dispatchPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        dispatchPlans: getAllDispatchPlans(state),
        addons: getAllAddons(state),
        dispatchSubscriptionId: getCurrentDispatchId(state),
        dispatchPlanId: getCurrentDispatchPlanId(state),
        currentDispatch: getCurrentDispatch(state),
        currentUser: getCurrentUser(state),
        requesting: requestingDispatchPlans(state),
    }),
    {
        requestDispatchPlans: requestPlansIfNotRequested,
        requestCurrentDispatch,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
    },
)(SelectDispatchPlan);
